import { Tooltip, Popconfirm, Button } from 'antd';
import { SaveOutlined, CloseOutlined } from '@ant-design/icons';

const SaveCancelTooltip = ({ onSave, onCancel }) => {
  return (
    <>
      <Tooltip title="Save">
        <Button
          icon={<SaveOutlined />}
          onClick={onSave}
          style={{ marginRight: 8 }}
          type="primary"
        />
      </Tooltip>
      <Popconfirm title="Cancel changes?" onConfirm={onCancel}>
        <Tooltip title="Cancel">
          <Button icon={<CloseOutlined />} />
        </Tooltip>
      </Popconfirm>
    </>
  );
};

export default SaveCancelTooltip;
